import { MAX_WIDTH } from '../../Settings'
import { Skeleton } from '@dashboard/ui'

export default function DashboardSkeleton() {
  return (
    <div>
      <div
        className="flex h-9 w-full items-center justify-end gap-3"
        style={{
          maxWidth: MAX_WIDTH,
        }}
      >
        <Skeleton className="mr-auto h-6 w-[505px]" />

        <Skeleton className="h-6 w-[93px]" />
        <Skeleton className="h-6 w-[93px]" />
        <Skeleton className="h-6 w-[93px]" />
      </div>

      <div className="flex flex-col gap-2">
        <div className="flex h-[287px] gap-2">
          <Skeleton className="h-[287px] w-full rounded-md" />
          <Skeleton className="h-[287px] w-full rounded-md" />
        </div>
        <Skeleton className="h-[287px] w-full rounded-md" />
        <Skeleton className="h-[960px] w-full rounded-md" />
      </div>
    </div>
  )
}
